import React from 'react';
import { Box } from '@mui/material';
import { useAppSelector, useTheme, useState } from 'hooks';
import { tokens } from 'theme';
import { DataGrid, GridFilterItem, GridToolbar } from '@mui/x-data-grid';
import { COLUMNS, INITIAL_RECORDS_LIMIT } from './constants/constants';
import styles from './styles.module.sass';

import { useStudyWaveforms } from '../../hooks/hooks';

export const StudyEcgs = () => {
  const { studyTableData, studyTotal } = useAppSelector(({ study }) => study);
  const [filter, setFilter] = useState<GridFilterItem[]>([]);
  const { isLoading, handleRowClick, onPaginationChangeHandler } = useStudyWaveforms();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      className={styles.details}
      sx={{
        '& .MuiDataGrid-root': {
          border: 'none',
          overflowY: 'hidden',
        },
        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
          width: '0.4em',
        },
        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
          background: '#f1f1f1',
        },
        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
          backgroundColor: colors.dashboard.secondary,
        },
        '& .MuiDataGrid-columnHeaders': {
          backgroundColor: colors.dashboard.secondary,
          borderBottom: 'none',
        },
        '& .MuiDataGrid-footerContainer': {
          borderTop: 'none',
          backgroundColor: colors.dashboard.secondary,
          marginBottom: '20px',
        },
        '& .MuiCheckbox-root': {
          color: `${colors.greenAccent[200]}`,
        },
        '& .MuiDataGrid-toolbarContainer .MuiButton-text': {
          color: `${colors.grey[100]} `,
        },
        '& .MuiTablePagination-root::-webkit-scrollbar': {
          width: '0.4em',
        },
        '& .MuiTablePagination-root::-webkit-scrollbar-track': {
          background: '#f1f1f1',
        },
        '& .MuiTablePagination-root::-webkit-scrollbar-thumb': {
          backgroundColor: colors.dashboard.secondary,
        },
      }}
    >
      <DataGrid
        rowHeight={70}
        rows={studyTableData}
        columns={COLUMNS}
        onRowClick={(params) => handleRowClick(params.id as string, params.row.status)}
        initialState={{
          pagination: { paginationModel: { pageSize: INITIAL_RECORDS_LIMIT, page: 0 } },
          sorting: {
            sortModel: [{ field: 'created_at', sort: 'desc' }],
          },
        }}
        pageSizeOptions={[INITIAL_RECORDS_LIMIT, 25, 50, 100]}
        getRowClassName={(params) => {
          return params.row.reference_url && 'highlight';
        }}
        density='compact'
        sx={{
          marginTop: '20px',
          overflowX: 'auto',
          cursor: 'pointer',
          '.highlight': {
            bgcolor: 'grey',
            '&:hover': {
              bgcolor: 'darkgrey',
            },
          },
        }}
        filterModel={{
          items: filter,
        }}
        onFilterModelChange={(newFilterModel) => setFilter(newFilterModel.items)}
        onPaginationModelChange={onPaginationChangeHandler}
        slots={{ toolbar: GridToolbar }}
        loading={isLoading}
        slotProps={{ toolbar: { showQuickFilter: true } }}
        paginationMode='server'
        rowCount={studyTotal}
      />
    </Box>
  );
};
